export enum NetworkErrorCode {
  SECURITY_PLEDGE_REQUIRED = "SECURITY_PLEDGE_REQUIRED",
}
